<template>
    <article>
        <div class="article-content">
            <h2>Page not found</h2>
            <p>Sorry, the page you are looking for does not exist.</p>
            <p>Please use the menu to navigate or <router-link to="/">return to the homepage</router-link>.</p>
        </div>
    </article>
</template>

<script setup lang="ts">
    import { useHead } from '@unhead/vue'

    useHead({
        title: 'Page Not Found',
        meta: [
            { name: 'robots', content: 'noindex' },
            { name: 'description', content: 'The page you are looking for does not exist.' },
            { property: 'og:title', content: 'Page Not Found - LCP Investment Fee Survey' },
            { property: 'og:description', content: 'The page you are looking for does not exist.' },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:title', content: 'Page Not Found - LCP Investment Fee Survey' },
            { name: 'twitter:description', content: 'The page you are looking for does not exist.' }
        ]
    })
</script>

<style lang="scss" scoped>
    .article-content {
        padding: 25px;
    }
    h2 {
        font-size: 1.5rem;
        font-weight: 700;
        padding: 0 0 20px 0;
        color: var(--lcp-blue);
        position: relative;
        margin-bottom: 20px;
        display: inline-block;

        &::before {
            content: '';
            position: absolute;
            bottom: 8px;
            left: 0;
            width: calc(100% - 10px);
            height: 3px;
            background: linear-gradient(to right,
                var(--investment-violet) 0%,
                var(--investment-violet) 50%,
                transparent 100%);
            border-radius: 2px;
        }

        &::after {
            content: '';
            position: absolute;
            bottom: 5px;
            left: 0px;
            width: 9px;
            height: 9px;
            background: var(--investment-violet);
            border-radius: 50%;
        }
    }
    p {
        margin-bottom: 15px;
    }
    a {
        color: var(--lcp-blue);
        font-weight: 700;
        text-decoration: underline;
        &:hover {
            color: var(--dark-orange);
        }
    }
</style>
